module.exports = __webpack_public_path__ + "static/scale-model-of-greensboro-north-carolina-782ccc923c8062d37b19a7a00f29dcad.png";